import { createContext, useContext, ReactNode } from "react";

interface StructureDisplayContextType {
  isPublicExponentDisplay: boolean;
}

const StructureDisplayContext = createContext<
  StructureDisplayContextType | undefined
>(undefined);

export const useStructureDisplay = () => {
  const context = useContext(StructureDisplayContext);
  if (context === undefined) {
    return { isPublicExponentDisplay: false };
  }
  return context;
};

interface StructureDisplayProviderProps {
  children: ReactNode;
  isPublicExponentDisplay?: boolean;
}

export const StructureDisplayProvider = ({
  children,
  isPublicExponentDisplay = false,
}: StructureDisplayProviderProps) => {
  return (
    <StructureDisplayContext.Provider value={{ isPublicExponentDisplay }}>
      {children}
    </StructureDisplayContext.Provider>
  );
};
